import React from "react";
import { Redirect, useLocation, useParams } from "react-router-dom";
import ViewProgram from "app/routes/ViewProgram";
import { useStoreActions } from "app/utils/hooks";
import { fetchSelf } from "app/actions/user";
import { Loading } from "app/components/Wrappers";

const PublicProgram = () => {
  const { user } = useStoreActions({ user: fetchSelf });
  const { program_id } = useParams<{ program_id: string }>();
  const location = useLocation();

  if (user?.pending) {
    return <Loading loadType="spinner" />;
  }

  if (user?.data) {
    // Logged-in users should view the authenticated route. Keep the query
    // string: links may carry coach_id, which drives the contact sync.
    return (
      <Redirect
        to={{ pathname: `/programs/${program_id}/view`, search: location.search }}
      />
    );
  } else {
    return <ViewProgram isPublic={true} />;
  }
};

export default PublicProgram;
